import { useState } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { articles } from '@/mocks/articles';
import { categories, hotTags } from '@/mocks/categories';

const hotArticles = articles.filter((a) => a.isHot);
const latestArticles = articles.sort(
  (a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime()
);

function formatViews(views: number): string {
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return views.toString();
}

export default function Home() {
  const [newsletterEmail, setNewsletterEmail] = useState('');
  const [newsletterStatus, setNewsletterStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [newsletterMsg, setNewsletterMsg] = useState('');

  const handleNewsletterSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = (formData.get('phone_alt') as string || '').trim();
    if (honeypot) {
      setNewsletterStatus('success');
      setNewsletterMsg('订阅成功！感谢您的关注。');
      return;
    }
    try {
      const res = await fetch('https://readdy.ai/api/form/d9q8ikfnahb7382ov7og', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ email: formData.get('email') as string }).toString(),
      });
      const responseText = await res.text();
      let parsed: any = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }
      if (res.ok && parsed?.code === 'OK') {
        setNewsletterStatus('success');
        setNewsletterMsg('订阅成功！感谢您的关注，最新瓜料将第一时间送达！');
        setNewsletterEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '订阅失败，请稍后再试';
        setNewsletterStatus('error');
        setNewsletterMsg(serverMsg);
      }
    } catch {
      setNewsletterStatus('error');
      setNewsletterMsg('网络错误，请稍后重试');
    }
  };

  const schemaData = {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Organization',
        name: '吃瓜网',
        url: 'https://xingyanx.cn',
        description: '吃瓜网是专注于娱乐八卦、明星热点、网络热门事件的资讯平台。',
        foundingDate: '2020-03',
        contactPoint: {
          '@type': 'ContactPoint',
          email: 'hello@xingyanx.cn',
          contactType: 'customer service',
        },
        sameAs: ['https://weibo.com/chiguawang'],
      },
      {
        '@type': 'WebSite',
        name: '吃瓜网',
        url: 'https://xingyanx.cn',
        description: '最新娱乐八卦吃瓜资讯平台',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'https://xingyanx.cn/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      },
      {
        '@type': 'WebPage',
        '@id': 'https://xingyanx.cn/#webpage',
        url: 'https://xingyanx.cn',
        name: '吃瓜网 - 最新娱乐八卦吃瓜资讯平台',
        description: '吃瓜网是专注于娱乐八卦、明星热点、网络热门事件的资讯平台。每天第一时间更新最新吃瓜内容。',
        isPartOf: { '@id': 'https://xingyanx.cn/#website' },
      },
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首页',
            item: 'https://xingyanx.cn',
          },
        ],
      },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(schemaData) }}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />

        {/* Hero */}
        <section className="relative h-[500px] md:h-[620px] flex items-center justify-center overflow-hidden">
          <img
            src="https://readdy.ai/api/search-image?query=A%20vibrant%20stylized%20digital%20art%20wallpaper%20with%20warm%20coral%20pink%20and%20deep%20magenta%20gradient%20background%2C%20abstract%20geometric%20shapes%20floating%2C%20modern%20social%20media%20news%20vibe%2C%20glowing%20particles%2C%20trendy%20aesthetic%2C%20young%20and%20energetic%20mood%2C%20editorial%20design%20feel&width=1800&height=900&seq=hero-bg-home-01&orientation=landscape"
            alt="吃瓜网 - 最新娱乐八卦吃瓜资讯平台"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
          <div className="relative z-10 w-full px-4 md:px-6 text-center">
            <div className="max-w-3xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
                <i className="ri-fire-line text-accent-400 text-sm"></i>
                <span className="text-sm text-background-50/90 font-medium">今日热搜 · 实时更新中</span>
              </div>
              <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-background-50 mb-4 leading-tight">
                随时随地，吃瓜不停
              </h1>
              <p className="text-base md:text-lg text-background-50/80 mb-8 max-w-xl mx-auto leading-relaxed">
                最新娱乐八卦、明星绯闻、网络热门事件，每天第一时间更新，让你不错过任何精彩瓜料
              </p>
              <div className="flex flex-wrap items-center justify-center gap-2">
                {hotTags.slice(0, 6).map((tag, i) => (
                  <span
                    key={i}
                    className="px-4 py-1.5 rounded-full bg-background-50/12 backdrop-blur-sm text-sm text-background-50/85 border border-background-50/15 whitespace-nowrap cursor-pointer hover:bg-background-50/20 transition-all"
                  >
                    #{tag}
                  </span>
                ))}
              </div>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
        </section>

        {/* Hot Topics */}
        <section className="w-full px-4 md:px-6 -mt-12 relative z-10">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-xl">
                <i className="ri-fire-line text-accent-600 text-xl"></i>
              </div>
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  今日热搜
                </h2>
                <p className="text-sm text-foreground-500">大家都在吃的瓜</p>
              </div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              {hotArticles.slice(0, 3).map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300/60 transition-all duration-300 cursor-pointer"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-3 py-1 rounded-full text-xs font-medium bg-accent-500 text-background-50">
                        {article.category}
                      </span>
                    </div>
                    <div className="absolute top-3 right-3">
                      <span className="px-2.5 py-1 rounded-full text-xs font-medium bg-background-950/60 backdrop-blur-sm text-background-50">
                        <i className="ri-eye-line mr-1"></i>
                        {formatViews(article.views)}
                      </span>
                    </div>
                  </div>
                  <div className="p-5">
                    <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                      {article.title}
                    </h3>
                    <p className="text-sm text-foreground-500 line-clamp-2 leading-relaxed mb-4">
                      {article.excerpt}
                    </p>
                    <div className="flex items-center justify-between text-xs text-foreground-400">
                      <span>{article.author}</span>
                      <span>{article.publishDate}</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Category Sections */}
        {categories.map((cat) => {
          const catArticles = articles.filter((a) => a.categorySlug === cat.slug).slice(0, 4);
          if (catArticles.length === 0) return null;
          return (
            <section key={cat.slug} className="w-full px-4 md:px-6 py-14">
              <div className="max-w-7xl mx-auto">
                <div className="flex items-center justify-between mb-6">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 flex items-center justify-center bg-secondary-100 rounded-xl">
                      <i className={`${cat.icon} text-secondary-600 text-xl`}></i>
                    </div>
                    <div>
                      <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                        {cat.name}
                      </h2>
                      <p className="text-sm text-foreground-500">{cat.description}</p>
                    </div>
                  </div>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    查看更多
                    <i className="ri-arrow-right-line"></i>
                  </Link>
                </div>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                  {catArticles.map((article, idx) => (
                    <Link
                      key={article.id}
                      to={`/article/${article.slug}`}
                      className={`group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300/60 transition-all duration-300 cursor-pointer ${
                        idx === 0 ? 'sm:col-span-2 sm:row-span-2' : ''
                      }`}
                    >
                      <div className={`relative ${idx === 0 ? 'h-56' : 'h-40'} overflow-hidden`}>
                        <img
                          src={article.coverImage}
                          alt={article.title}
                          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                        />
                      </div>
                      <div className="p-4">
                        <h3 className={`font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug ${
                          idx === 0 ? 'text-base' : 'text-sm'
                        }`}>
                          {article.title}
                        </h3>
                        <p className={`text-foreground-500 line-clamp-2 leading-relaxed mt-1.5 ${
                          idx === 0 ? 'text-sm' : 'text-xs'
                        }`}>
                          {article.excerpt}
                        </p>
                        <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
                          <span>{article.publishDate}</span>
                          <span>{formatViews(article.views)} 阅读</span>
                        </div>
                      </div>
                    </Link>
                  ))}
                </div>
              </div>
            </section>
          );
        })}

        {/* Latest Articles */}
        <section className="w-full px-4 md:px-6 py-14 bg-background-100">
          <div className="max-w-7xl mx-auto">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-xl">
                <i className="ri-newspaper-line text-primary-600 text-xl"></i>
              </div>
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-900">
                  最新爆料
                </h2>
                <p className="text-sm text-foreground-500">实时更新的吃瓜资讯</p>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
              {latestArticles.slice(0, 9).map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group bg-background-50 rounded-2xl overflow-hidden border border-background-200/60 hover:border-primary-300/60 transition-all duration-300 cursor-pointer flex flex-col sm:flex-row lg:flex-col"
                >
                  <div className="relative h-40 sm:h-auto sm:w-36 lg:w-full lg:h-44 overflow-hidden shrink-0">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-2 left-2">
                      <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-primary-500 text-background-50">
                        {article.category}
                      </span>
                    </div>
                  </div>
                  <div className="p-4 flex flex-col justify-between flex-1">
                    <div>
                      <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                        {article.title}
                      </h3>
                      <p className="text-xs text-foreground-500 line-clamp-2 leading-relaxed mt-2">
                        {article.excerpt}
                      </p>
                    </div>
                    <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
                      <span>{article.publishDate}</span>
                      <span>{formatViews(article.views)} 阅读</span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        {/* Newsletter */}
        <section className="w-full px-4 md:px-6 py-16">
          <div className="max-w-2xl mx-auto text-center">
            <div className="w-14 h-14 mx-auto flex items-center justify-center bg-accent-100 rounded-2xl mb-5">
              <i className="ri-mail-send-line text-accent-600 text-2xl"></i>
            </div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-3">
              订阅吃瓜简讯
            </h2>
            <p className="text-sm text-foreground-500 mb-7 leading-relaxed">
              第一时间获取最新瓜料，精彩内容不错过。每周推送，随时可退订。
            </p>
            <form
              onSubmit={handleNewsletterSubmit}
              data-readdy-form
              className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
            >
              <input
                type="text"
                name="phone_alt"
                className="antispam-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
                readOnly
              />
              <input
                type="email"
                name="email"
                value={newsletterEmail}
                onChange={(e) => setNewsletterEmail(e.target.value)}
                placeholder="输入你的邮箱地址"
                required
                className="flex-1 px-5 py-3 rounded-xl bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
              />
              <button
                type="submit"
                className="px-6 py-3 rounded-xl bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                立即订阅
              </button>
            </form>
            {newsletterStatus !== 'idle' && (
              <p className={`mt-4 text-sm ${newsletterStatus === 'success' ? 'text-green-600' : 'text-red-500'}`}>
                {newsletterMsg}
              </p>
            )}
          </div>
        </section>

        <Footer />
      </div>
    </>
  );
}